import React from 'react';
import { Role } from '../../../../shared/services/userService';
import usePageTranslation from '../../../../shared/hooks/usePageTranslation';

interface UserFiltersProps {
  searchTerm: string;
  selectedRole: number | '';
  roles: Role[];
  onSearchChange: (value: string) => void;
  onRoleChange: (value: number | '') => void;
}

const UserFilters: React.FC<UserFiltersProps> = ({
  searchTerm,
  selectedRole,
  roles,
  onSearchChange,
  onRoleChange
}) => {
  const { t } = usePageTranslation('panel', 'UserRolesManagement');

  return (
    <div className="rounded-xl border border-[#223046]/90 bg-[#0e1522]/90 p-4 backdrop-blur-sm mb-4">
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-cockpit-text-2 mb-1.5">
            {t('filters.search')}
          </label>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder={t('filters.searchPlaceholder')}
            className="w-full rounded-lg border border-[#223046] bg-[#0b1220] px-3 py-2 text-sm text-cockpit-text placeholder-cockpit-muted focus:outline-none focus:border-[#6366f1]/60"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-cockpit-text-2 mb-1.5">
            {t('filters.role')}
          </label>
          <select
            value={selectedRole}
            onChange={(e) => onRoleChange(e.target.value ? Number(e.target.value) : '')}
            className="w-full rounded-lg border border-[#223046] bg-[#0b1220] px-3 py-2 text-sm text-cockpit-text focus:outline-none focus:border-[#6366f1]/60"
          >
            <option value="">{t('filters.allRoles')}</option>
            {roles.map((role) => (
              <option key={role.id} value={role.id}>
                {role.role_name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default UserFilters;
